// extracted by mini-css-extract-plugin
module.exports = {"paper":"styles_paper__1Nmvo","picture":"styles_picture__1ZBIp","uploader":"styles_uploader__29h_c"};